// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Aeek2UPZJZVXg1 {
  padding-left: var(--ds-space-100, 8px);
}
.tjU9nZ_e247AA6 {
  padding-top: var(--ds-space-025, 2px);
}
.tjU9nZ_e247AA6 span {
  width: 16px;
  height: 16px;
}
`, ""]);
// Exports
export var textPadding = `Aeek2UPZJZVXg1`;
export var iconContainer = `tjU9nZ_e247AA6`;
export default ___CSS_LOADER_EXPORT___;
